'use client';
var classes = {"root":"m_7cda1cd6","root--default":"m_44da308b","root--contrast":"m_e3a01f8","label":"m_1e0e6180","remove":"m_ae386778","group":"m_1dcfd90b"};

export { classes as default };
//# sourceMappingURL=Pill.module.css.mjs.map
